/**
 * Determines if a price should show strikethrough formatting
 * @param {number} rawPrice - The current price
 * @param {number} compareAtPrice - The price to compare against
 * @returns {boolean} Whether the price should show strikethrough
 */
const shouldShowStrikethroughProductCardUtil = ({ rawPrice, compareAtPrice }) => {
  return rawPrice === 0 && rawPrice !== compareAtPrice && compareAtPrice > 0 && compareAtPrice > rawPrice
}

export default shouldShowStrikethroughProductCardUtil
